import { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FeaturesGrid from './components/FeaturesGrid';
import IndustryShowcase from './components/IndustryShowcase';
import ROICalculator from './components/ROICalculator';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import PartnersSection from './components/PartnersSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        <HeroSection />
        <FeaturesGrid />
        <IndustryShowcase />
        {/* <ROICalculator /> */}
        <TestimonialsCarousel />
        {/* <PartnersSection /> */}
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default Homepage;